const handleCancelActionFormActions = {
  confirm: 'Do you really want to cancel this action?',
  title: 'CANCEL ACTION',
  newStatus: 'Called off'
};

export default handleCancelActionFormActions;
